<template>
	<el-container>
		<left-nav></left-nav>
		<el-main>
			<right-pane></right-pane>
		</el-main>
	</el-container>
</template>
<script>
import LeftNav from '../LeftNav/LeftNav'
import RightPane from '../RightPane/RightPane'

export default {
    name: 'Home',
    components: {
        LeftNav,
        RightPane
    }
}
</script>
<style>
.el-container{
	height: 100%;
}
.el-main{
	padding: 0 !important;
}
</style>




// WEBPACK FOOTER //
// Index.vue?1c6f815b